import { type ComponentProps } from "react";

const GestionIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg
      width="25"
      height="27"
      viewBox="0 0 25 27"
      fill="currentColor"
      {...props}
    >
      <path d="M3.125 25C2.26562 25 1.53021 24.6943 0.91875 24.0828C0.30625 23.4703 0 22.7344 0 21.875V10.9375C0 10.0781 0.30625 9.34219 0.91875 8.72969C1.53021 8.11823 2.26562 7.8125 3.125 7.8125C3.98438 7.8125 4.71979 8.11823 5.33125 8.72969C5.94375 9.34219 6.25 10.0781 6.25 10.9375V21.875C6.25 22.7344 5.94375 23.4703 5.33125 24.0828C4.71979 24.6943 3.98438 25 3.125 25ZM12.5 25C11.6406 25 10.9052 24.6943 10.2938 24.0828C9.68125 23.4703 9.375 22.7344 9.375 21.875V3.125C9.375 2.26562 9.68125 1.53021 10.2938 0.91875C10.9052 0.30625 11.6406 0 12.5 0C13.3594 0 14.0953 0.30625 14.7078 0.91875C15.3193 1.53021 15.625 2.26562 15.625 3.125V21.875C15.625 22.7344 15.3193 23.4703 14.7078 24.0828C14.0953 24.6943 13.3594 25 12.5 25ZM21.875 25C21.0156 25 20.2797 24.6943 19.6672 24.0828C19.0557 23.4703 18.75 22.7344 18.75 21.875V17.1875C18.75 16.3281 19.0557 15.5922 19.6672 14.9797C20.2797 14.3682 21.0156 14.0625 21.875 14.0625C22.7344 14.0625 23.4703 14.3682 24.0828 14.9797C24.6943 15.5922 25 16.3281 25 17.1875V21.875C25 22.7344 24.6943 23.4703 24.0828 24.0828C23.4703 24.6943 22.7344 25 21.875 25Z" />
    </svg>
  );
};

GestionIcon.displayName = "GestionIcon";

export default GestionIcon;
